import React, { useContext, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AdminAuthContext } from "../context/AdminAuthContext";

export const RequireAdminAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { admin } = useContext(AdminAuthContext);
  const location = useLocation();
  if (!admin) {
    // Remember where they were headed (e.g. a review link from the founder
    // email) so signing in lands them back there, not on the dashboard.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }
  return <>{children}</>;
};

export const RequireNoAdminAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { admin } = useContext(AdminAuthContext);
  if (admin) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <>{children}</>;
};
